import { ElMessageBox, ElNotification } from 'element-plus'
import type { App } from 'vue'

export default {
  install(app: App) {
    // Async confirm dialog
    app.config.globalProperties.$confirm = async (
      message: string,
      title = 'Confirm',
      options = {}
    ) => {
      return ElMessageBox.confirm(message, title, {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        ...options
      })
    }

    // Notification methods
    app.config.globalProperties.$error = (message: string, title = 'Error') => {
      ElNotification.error({
        title,
        message,
        duration: 5000
      })
    }

    app.config.globalProperties.$warning = (message: string, title = 'Warning') => {
      ElNotification.warning({
        title,
        message,
        duration: 5000
      })
    }

    app.config.globalProperties.$info = (message: string, title = 'Info') => {
      ElNotification.info({
        title,
        message,
        duration: 3000
      })
    }

    app.config.globalProperties.$success = (message: string, title = 'Success') => {
      ElNotification.success({
        title,
        message,
        duration: 3000
      })
    }
  }
}
